






















































































































import { ExtendedLineItem } from "@/components/repair-estimate/LineItemsForm.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { AccountingTypeEnum, IProduct } from "@/models/product.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { currencySymbolMap } from "@/store/mapper/currency-symbol.map";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { ProductModule } from "@/store/modules/product.store";
import { debounce } from "debounce";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {},
  filters: {}
})
export default class InvoiceFormLinesTableRow extends mixins(PermissionMixin, RulesMixin) {
  readonly formatCurrency = formatCurrency;

  readonly currencySymbolMap = currencySymbolMap;

  @Prop()
  value!: ExtendedLineItem;

  @Prop()
  currency!: CurrencyEnum;

  @Prop()
  accountingType?: AccountingTypeEnum;

  @Prop()
  index!: number;

  @Prop({ default: true })
  readonly!: string;

  get canReadProduct() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.PRODUCT, this.permissionPartnerId);
  }

  get products() {
    return ProductModule.entities;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get taxRates() {
    return this.partner.settings?.taxRates;
  }

  debounceTimeout = 300;

  debouncedProductSearch = debounce(
    (search: string, item?: ExtendedLineItem) => this.searchProduct(search, item),
    this.debounceTimeout,
    false
  );

  async searchProduct(search: string, item?: ExtendedLineItem) {
    if (!item || !search) {
      return;
    }

    item.search = search;
    item.isLoading = true;

    try {
      ProductModule.setSearch(item.search);
      await ProductModule.fetchPage({ partnerId: this.partner.id });
    } catch (e) {
      handleError(e);
    } finally {
      item.isLoading = false;
    }
  }

  onProductInput(e: IProduct) {
    this.value.product = e;
    this.addAsLineItem(this.value);
  }

  addAsLineItem(lineItem: ExtendedLineItem) {
    if (!lineItem || !lineItem.product) {
      return;
    }

    this.$log.debug(lineItem);

    const productLineItem = lineItem.product as IProduct;
    if (productLineItem.title) {
      lineItem.setFromProduct(productLineItem, this.accountingType);
    } else {
      lineItem.title = lineItem.product as string;
    }
  }
}
